/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useResize } from '../../hooks'
import { GrClose } from 'react-icons/gr';
import { Wrapper, Container, MenuContainer, StyledClose, MenuContent } from './index.styled'
import { MapExpanded } from '../../components'
import { store } from './../../effects/store';
import { setMenu, setMenuContent } from './../../effects/actions'
import {
  PanoramasPage, ProductsPage, ProductDetailPage, MenuCardsPage,
  ProcessesPage, AmorimGroupPage
} from './../../pages'
import MenuContainerComponent from './container'

const MenuComponent = ({ setOpen, menuOpen, menuContent, setMenuContent }) => {

  const isMobile = useResize().isMobile;

  const renderContent = () => {
    switch (menuContent) {
      case 'map':
        return <MapExpanded setMenuContent={setMenuContent} />

      case 'products':
        return <ProductsPage setMenuContent={setMenuContent} />

      case 'wise':
        return <ProductsPage setMenuContent={setMenuContent} />

      case 'wicanders':
        return <ProductsPage setMenuContent={setMenuContent} />

      case 'panoramas':
        return <PanoramasPage setMenuContent={setMenuContent} />

      case 'factory':
        return <PanoramasPage pano="factory" setMenuContent={setMenuContent} />

      case 'raw-material':
        return <ProcessesPage id="raw-material" setMenuContent={setMenuContent} />

      case 'components':
        return <ProcessesPage id="components" setMenuContent={setMenuContent} />

      case 'finishing-1':
        return <ProcessesPage id="finishing-1" setMenuContent={setMenuContent} />

      case 'finishing-2':
        return <ProcessesPage id="finishing-2" setMenuContent={setMenuContent} />

      case 'process':
        return <ProcessesPage id="all" setMenuContent={setMenuContent} />

      case 'product':
        return <ProductDetailPage setMenuContent={setMenuContent} />

      case 'menu-cards':
        return <MenuCardsPage setMenuContent={setMenuContent} />

      case 'amorim-group':
        return <AmorimGroupPage setMenuContent={setMenuContent} />

      default:
        return null;
    }
  }

  useEffect(() => {
    if(isMobile) {
      document.body.style.background = '#FFF';
    }
    return () => {
      if(isMobile) {
        document.body.style.background = null;
      }
    }
  },[isMobile])
  return (
    <Wrapper className={menuOpen ? 'open' : 'closed'}>
      {menuContent === 'map' && <StyledClose onClick={() => store.dispatch(setMenu(false))}><GrClose /></StyledClose>}
      <Container className={menuOpen ? 'open' : 'closed'}>
        
        {!isMobile &&
          <MenuContainer>
            <MenuContainerComponent showSharedIcons={true} showFactory={true} setOpen={setOpen} isMap={menuContent === 'map'} />
          </MenuContainer>
        }
        {isMobile && menuContent === null &&
          (<MenuContainer>
            <MenuContainerComponent
              showSharedIcons={true}
              showFactory={true}
              setOpen={setOpen}
              isMap={menuContent === 'map'}
            />
          </MenuContainer>
          )
        }

        <MenuContent>
          {renderContent()}
        </MenuContent>
      </Container>
    </Wrapper>
  )
}


const mapStateToProps = ({ app }) => {
  const { menuOpen, menuContent } = app

  return {
    menuOpen, menuContent
  }
}

export default connect(mapStateToProps, {
  setMenu,
  setMenuContent
})(React.memo(MenuComponent))